import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

// Country - Get All
export const AllState = createAsyncThunk(
  "/state",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllState}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllDistrict = createAsyncThunk(
  "/district",
  async ({ state_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllDistrict}?state_id=${state_id}&name=${name}`,
        {
          headers: {
            platform: process.env.REACT_APP_PLATFORM,
            appversion: process.env.REACT_APP_APP_VERSION,
          },
        },
      );

      return await Select2Data(res.data, "district_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTaluka = createAsyncThunk(
  "/taluqa",
  async ({ district_id, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTaluka}?district_id=${district_id}&name=${name}`,
        {
          headers: {
            platform: process.env.REACT_APP_PLATFORM,
            appversion: process.env.REACT_APP_APP_VERSION,
          },
        },
      );

      return await Select2Data(res.data, "taluqa_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCartegory = createAsyncThunk(
  "/servicecategory",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCartegory}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });

      return await Select2Data(res.data, "category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProfession = createAsyncThunk(
  "/get-profession",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllProfession}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });

      return await Select2Data(res.data, "profession_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllPrivacyPolicy = createAsyncThunk(
  "common/masters/privacy-policy",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPrivacyPolicy);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTermcondition = createAsyncThunk(
  "common/masters/termcondition",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTermcondition);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAppSetup = createAsyncThunk(
  "common/masters/app-set-up",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAppSetup);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllCategories = createAsyncThunk(
  "common/masters/servicecategoryss",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllCategories);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllProfessions = createAsyncThunk(
  "common/masters/get-professionsss",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllProfessions);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllPurchaseDate = createAsyncThunk(
  "/get-purchase-date",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPurchaseDate}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      return await Select2Data(res.data, "purchase_date");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllBanners = createAsyncThunk(
  "common/masters/banner",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBanners);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllAboutUs = createAsyncThunk(
  "common/masters/web-about-us",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllAboutUs);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllKilometer = createAsyncThunk(
  "/kilometers",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllKilometer}?name=${filter}`, {
        headers: {
          platform: process.env.REACT_APP_PLATFORM,
          appversion: process.env.REACT_APP_APP_VERSION,
        },
      });
      console.log(res, "resres");

      return await Select2Data(res.data, "kilometer_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const AllNotification = createAsyncThunk(
//   "common/masters/getnoti",
//   async (filter, { rejectWithValue }) => {
//     try {
//       const res = await GET(APIS.Commons.AllNotification);

//       return res?.data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

  export const AllSubServiceCategories = createAsyncThunk(
    "/sub-service-categories",
    async ({ service_category_id = [], name = "" }, { rejectWithValue }) => {
      try {
        const ids = service_category_id
          .map((id) => `service_category_id[]=${id}`)
          .join("&");

        const res = await GET(
          `${APIS.Commons.AllSubServiceCategories}?${ids}&name=${name}`,
          {
            headers: {
              platform: process.env.REACT_APP_PLATFORM,
              appversion: process.env.REACT_APP_APP_VERSION,
            },
          },
        );

        return await Select2Data(res.data, "category_id");
      } catch (error) {
        return rejectWithValue(error.message);
      }
    },
  );

export const AllSubProfession = createAsyncThunk(
  "/sub-profession",
  async ({ profession_id = [], name = "" }, { rejectWithValue }) => {
    try {
      const ids = profession_id.map((id) => `profession_id[]=${id}`).join("&");

      const res = await GET(
        `${APIS.Commons.AllSubProfession}?${ids}&name=${name}`,
        {
          headers: {
            platform: process.env.REACT_APP_PLATFORM,
            appversion: process.env.REACT_APP_APP_VERSION,
          },
        },
      );

      return Select2Data(res.data, "sub_profession_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_state: [],
    all_district: [],
    all_category: [],
    all_profession: [],
    all_privacy_policy: [],
    all_terms_condition: [],
    all_app_setup: [],
    all_categories: [],
    all_professions: [],
    all_purchase_date: [],
    all_taluka: [],
    all_banner: [],
    all_about_us: [],
    all_kilometer: [],
    all_sub_service_categories: [],
    all_sub_professions: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllDistrict.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDistrict.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_district = action.payload || [];
      })
      .addCase(AllDistrict.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTaluka.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTaluka.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_taluka = action.payload || [];
      })
      .addCase(AllTaluka.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCartegory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCartegory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCartegory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProfession.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProfession.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_profession = action.payload || [];
      })
      .addCase(AllProfession.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPrivacyPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPrivacyPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacy_policy = action.payload;
      })
      .addCase(AllPrivacyPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllTermcondition.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTermcondition.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_terms_condition = action.payload;
      })
      .addCase(AllTermcondition.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_app_setup = action.payload;
      })
      .addCase(AllAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCategories.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategories.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_categories = action.payload;
      })
      .addCase(AllCategories.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllProfessions.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllProfessions.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_professions = action.payload;
      })
      .addCase(AllProfessions.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllPurchaseDate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPurchaseDate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_purchase_date = action.payload || [];
      })
      .addCase(AllPurchaseDate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBanners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBanners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banner = action.payload || [];
      })
      .addCase(AllBanners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllAboutUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAboutUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_about_us = action.payload || [];
      })
      .addCase(AllAboutUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllKilometer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllKilometer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_kilometer = action.payload || [];
      })
      .addCase(AllKilometer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubServiceCategories.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubServiceCategories.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sub_service_categories = action.payload || [];
      })
      .addCase(AllSubServiceCategories.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSubProfession.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSubProfession.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_sub_professions = action.payload || [];
      })
      .addCase(AllSubProfession.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
